module.exports = __webpack_public_path__ + "static/logo-3ebfdbfeecd16858ac77a402d5286051.svg";